export enum EFilters {
  LIVE = 'live',
  DRAFT = 'draft',
  ARCHIVED = 'archived',
}

// NON Working hours -> 20:00 to 06:00
// Working hours -> 06:00 to 20:00
export const WORKING_HOURS = {
  START: '06:00',
  END: '20:00',
};

